import { divide } from 'lodash';
import React from 'react';
import { connect } from 'react-redux';

class FormInput extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className={this.props.classes ?? ""}>
                <input
                    className={(this.props.classes ? this.props.classes + " " : "") + "w-100 second-input input-primary"}
                    type={this.props.type ?? "text"}
                    placeholder={this.props.placeholder ?? ""}
                    onChange={this.props.onChange ?? null}
                    defaultValue={this.props.defaultValue ?? ""}
                />
            </div>
        );
    }
}

function mapStateToProps(state) {
    return { state: state }
}

export default connect(mapStateToProps)(FormInput);
